<template>
  <div id="page-layout">
    <div id="page-header">
      <div class="page-title-layout">
        <p>{{$t("header.my_profile")}}</p>
      </div>
    </div>
    <div class="block-content">
      <div class="grid-title">
        <div class="column">
          <div class="big-avatar-circle">
            <span class="initials">{{Utils.getInitials(profile)}}</span>
          </div>
          <div>
            <div class="display-name">{{profile.displayName}}</div>
            <div class="email-blue">{{profile.email}}</div>
          </div>
        </div>
        <div class="actions">
          <button class="solid-button" type="button" v-on:click="editUser(profile.id)">{{$t('actions.edit_profile')}}
          </button>
        </div>
      </div>
      <div class="grid-data" v-if="isClient()">
        <div class="info-title">{{$t("user.company")}}</div>
        <div class="info-value">{{profile.companyName}}</div>
        <div class="info-title">{{$t("user.responsible")}}</div>
        <div class="info-value">{{profile.responsibleName}}</div>
        <div class="bottom-border"></div>
      </div>
      <div class="grid-data">
        <div class="info-title">{{$t("user.language")}}</div>
        <div class="info-value">{{$t(`languages.${profile.locale}`)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Roles from "../models/Roles.js"
  import Profile from "../models/Profile.js"
  import userService from "../services/userService.js"
  import Utils from "../services/utils.js";

  export default {
    data() {
      return {
        Utils: Utils,
        profile: new Profile(),
        responsibleName: ''
      };
    },
    watch: {
      '$route'(to, from) {
        if (to.params.pageMode !== this.pageMode) {
          this.loadUser();
        }
      }
    },
    methods: {
      isClient() {
        return this.profile.role === Roles.client;
      },
      editUser() {
        this.$router.push({name: 'profileEdit'})
      },
      loadUser() {
        userService.getCurrentUser().then(user => {
          this.profile = user;
        });
      }
    },
    mounted() {
      this.loadUser();
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/profil.scss';

  #page-layout {
    display: grid;
    grid-template-columns: 20% [content] auto 20%;
  }

  #page-header {
    @extend %common-header;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/pages/manageProfile.vue